/** Looping welcome hub background video (loaded after first paint on web). */
export const WELCOME_VIDEO_PATH = '/background.mp4';

/** Still frame shown until welcome video is ready (deploy alongside background.mp4). */
export const WELCOME_VIDEO_POSTER_PATH = '/welcome_background_poster.jpg';

/** Brand mark for boot splash and auth. */
export const BOOT_LOGO_PATH = '/images/logo.png';
